/**
 * Formátovanie peňažných súm podľa globálnej meny (symbol z Jednotiek).
 * Deleguje na kanonický formatCurrency (Phase 2). Legacy signature zachovaná.
 */
import { formatCurrency as formatCurrencyCanonical } from './formatters';

/**
 * Naformátuje sumu s 2 desatinnými miestami a symbolom meny.
 * @param {number|string|null|undefined} value - suma
 * @param {string} currencySymbol - symbol z globálnych nastavení (napr. €, $)
 * @param {string} [locale='sk'] - UI locale sk|en|de
 * @returns {string}
 */
export function formatCurrency(value, currencySymbol = '€', locale = 'sk') {
  return formatCurrencyCanonical(value, { currency: currencySymbol, locale, empty: '' });
}
